import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Section,
  Warning,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const PGDLibrary = () => (
  <Page
    title="PGD Library"
    intro="The Patient Group Direction (PGD) library manages access, versioning, and sign-off for PGDs."
  >
    <Section title="Using the library">
      <Bullets>
        <Bullet>
          Open <DocLink url="/pgd-library" text="PGD Library" /> to browse
          PGDs and open an individual PGD to view its current version, version
          changes, and review date.
        </Bullet>
        <Bullet>
          Eligible staff sign a PGD electronically to confirm they have read
          and understood it. Signing is only offered to staff with a
          professional registration number (body and number) recorded on
          their employee profile, and the signer must re-enter their AmbuNet
          password to confirm the signature is theirs.
        </Bullet>
        <Bullet>
          Governance users add new PGDs, upload new versions, and remove
          withdrawn ones.
        </Bullet>
        <Bullet>
          When a PGD has been reviewed, open it and choose Upload new version.
          The reviewed document becomes the PGD staff sign, and the previous
          version is archived with its signatures kept on record.
        </Bullet>
        <Bullet>
          Staff only see PGDs that are within their review date. The Past
          review date and Archived views are visible to the Manager,
          Governance, Personnel, and Supervisor teams. A PGD past its review
          date counts as out of date in your KPIs until a new version is
          uploaded or it is archived.
        </Bullet>
      </Bullets>
      <Warning title="A PGD needs a review date">
        A PGD with no review date recorded counts as past its review date, so
        it is hidden from staff until a review date is set. Always record the
        review date when adding a PGD or uploading a new version.
      </Warning>
      <Info title="Who can do this?">
        Any signed-in user can view the library and (if they hold a recorded
        professional registration) sign a PGD. Adding, editing, or deleting
        PGDs requires the Governance team (site administrators always have
        access). PGD management is a tier 2 feature.
      </Info>
    </Section>
  </Page>
)

export default PGDLibrary
